import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import cls from './ForbiddenPage.module.scss';

const ForbiddenPage = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'forbidden-page',
  });

  return (
    <div className={cls['container']}>
      <div className={cls['content-box']}>
        <h1 className={cls['title']}>403</h1>
        <hr className={cls['stroke']} />
        <p className={cls['description']}>{t('description')}</p>
        <Link to={'/'} replace={true} className={cls['link']}>
          {t('link-title')}
        </Link>
      </div>
    </div>
  );
};

export default ForbiddenPage;
